import { useState } from 'react';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import PortalLayout from '../../layouts/PortalLayout';
import { SidebarUser, SidebarLabel, SidebarNavItem } from '../../layouts/SidebarNav';
import { PortalCard, StatsRow, DataTable } from './_portal.css';

const MENU = [
  { id: 'overview', icon: '📊', label: 'System Overview' },
  { id: 'users', icon: '👥', label: 'All Users' },
  { id: 'roles', icon: '🔑', label: 'Roles & Perms' },
  { id: 'audit', icon: '📜', label: 'Audit Log' },
  { id: 'system', icon: '⚙️', label: 'System Config' },
  { id: 'api', icon: '🔌', label: 'API Keys' },
  { id: 'billing', icon: '💳', label: 'Billing & Plans' },
  { id: 'security', icon: '🛡️', label: 'Security' },
];

const SiteAdmin = () => {
  const [active, setActive] = useState('overview');

  return (
    <PortalLayout
      brand="TrustLab"
      brandSub="Site Admin"
      accent="#8B5CF6"
      topbarTitle="SITE ADMINISTRATION"
      topbarRight={
        <Stack direction="row" spacing={1} alignItems="center">
          <Typography
            sx={{
              fontSize: { xs: 9, sm: 11 },
              fontWeight: 700,
              color: '#EF4444',
              bgcolor: '#FEE2E2',
              px: { xs: 1, sm: 1.5 },
              py: 0.5,
              borderRadius: 10,
              letterSpacing: '0.08em',
              whiteSpace: 'nowrap',
            }}
          >
            ● ROOT
          </Typography>
          <Button variant="outlined" size="small" sx={{ display: { xs: 'none', sm: 'inline-flex' } }}>
            System Logs
          </Button>
        </Stack>
      }
      sidebar={
        <>
          <SidebarUser initials="SA" name="Site Admin" role="Super User" avatarColor="#8B5CF6" />
          <SidebarLabel>Administration</SidebarLabel>
          {MENU.map((m) => (
            <SidebarNavItem key={m.id} {...m} active={active === m.id} onClick={() => setActive(m.id)} />
          ))}
        </>
      }
    >
      <StatsRow
        items={[
          { label: 'Total Users', value: '128.4K', sub: '+2.1K this week', accent: '#8B5CF6' },
          { label: 'Active Sessions', value: 3472, sub: 'Peak: 4.8K', accent: '#00B49A' },
          { label: 'API Calls/day', value: '2.4M', sub: 'Avg 48ms', accent: '#F0B429' },
          { label: 'Uptime (30d)', value: '99.98%', sub: 'SLA: 99.9%', accent: '#6366F1' },
        ]}
      />

      <Grid container spacing={2.5}>
        <Grid item xs={12} md={7}>
          <PortalCard title="User Activity · Last 24h">
            <Stack spacing={1.5}>
              {[
                ['Individual', 2846, 68, '#00B49A'],
                ['Medical Professional', 312, 8, '#6366F1'],
                ['Lab Partners', 187, 4, '#F0B429'],
                ['Corporate HR', 94, 2, '#EC4899'],
                ['QA / Internal', 33, 1, '#EF4444'],
              ].map(([r, u, pct, clr]) => (
                <Box key={r}>
                  <Stack direction="row" justifyContent="space-between" sx={{ mb: 0.5 }}>
                    <Typography sx={{ fontSize: 13, fontWeight: 700, color: '#10151C' }}>{r}</Typography>
                    <Typography sx={{ fontSize: 12, color: '#6B8079' }}>
                      {u.toLocaleString()} active · {pct}%
                    </Typography>
                  </Stack>
                  <Box sx={{ height: 8, bgcolor: '#F4F6F8', borderRadius: 10, overflow: 'hidden' }}>
                    <Box sx={{ height: '100%', width: `${pct}%`, bgcolor: clr, borderRadius: 10 }} />
                  </Box>
                </Box>
              ))}
            </Stack>
          </PortalCard>
        </Grid>
        <Grid item xs={12} md={5}>
          <PortalCard title="System Health">
            <Stack spacing={1.25}>
              {[
                ['API Gateway', 'Operational', '#00B49A'],
                ['Database · Primary', 'Operational', '#00B49A'],
                ['Database · Replica', 'Operational', '#00B49A'],
                ['Storage (S3)', 'Operational', '#00B49A'],
                ['Payment Gateway', 'Degraded', '#F0B429'],
                ['SMS / WhatsApp', 'Operational', '#00B49A'],
              ].map(([s, st, clr]) => (
                <Stack
                  key={s}
                  direction="row"
                  justifyContent="space-between"
                  alignItems="center"
                  sx={{ p: 1.5, bgcolor: '#F4F6F8', borderRadius: '6px' }}
                >
                  <Typography sx={{ fontSize: 13, color: '#10151C', fontWeight: 600 }}>{s}</Typography>
                  <Stack direction="row" spacing={1} alignItems="center">
                    <Box sx={{ width: 8, height: 8, borderRadius: '50%', bgcolor: clr }} />
                    <Typography sx={{ fontSize: 11, fontWeight: 700, color: clr, letterSpacing: '0.04em' }}>
                      {st}
                    </Typography>
                  </Stack>
                </Stack>
              ))}
            </Stack>
          </PortalCard>
        </Grid>
        <Grid item xs={12}>
          <PortalCard title="Recent Audit Events">
            <DataTable
              columns={['Time', 'Actor', 'Action', 'Target', 'IP']}
              rows={[
                ['10:48 AM', 'admin@trustlab', 'Role updated', 'user_341', '10.0.1.42'],
                ['10:31 AM', 'qa@trustlab', 'Complaint closed', 'TL-71198', '10.0.1.88'],
                ['09:59 AM', 'system', 'Backup completed', 'daily-apr14.sql', 'system'],
                ['09:14 AM', 'ops@trustlab', 'Centre created', 'NRL Noida-62', '10.0.1.12'],
                ['08:02 AM', 'siteadmin', 'API key rotated', 'key_prod_v4', '10.0.1.2'],
              ]}
            />
          </PortalCard>
        </Grid>
      </Grid>
    </PortalLayout>
  );
};

export default SiteAdmin;
